import styled from "styled-components"

export const Container = styled.div`
  margin-top: 10px;
  color: #ff2230;
  border-radius: 8px;
  display: flex;
`

export const Message = styled.div`
  margin-left: 10px;
`
